/**
 * 组件对外出口：按「布局 / 顶栏操作」归类，避免业务页散落 import 路径。
 * - 布局：`Footer`、`ContentToolbar`（side 布局下内容区顶栏）
 * - 顶栏：`AvatarDropdown`、`ThemeToggle`、`SelectLang`（积分与客服见 `ContentToolbar` 内建）
 */
export * from './layout';
export * from './toolbar';
export * from './menu';
export * from './theme';
export * from './sider';
export * from './dropdown';
export * from './ai';
export * from './assets';
export { MyGeneratedLink } from './MyGeneratedLink';

// 兼容旧的 named export 使用方式（上面已 re-export）
